import React, { Fragment, useState, useEffect } from 'react'
import { Badge, Button, Card, Col, Row } from 'react-bootstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import callApi from '../../helpers/callapi'
import styled from 'styled-components'
import AddModal from './AddModal'
import AdminDetailModal from './AdminModal'
import { useDispatch } from 'react-redux'
import CONSTANTS from '../../constants/constants'

import Pagination from '../../components/Nav/Pagination'

const BadgeCustom = styled(Badge)`
  margin-right: 5px;
  margin-bottom: 5px;
`
const CardBadge = styled.div`
  width: 500px;
  height: 200px;
`
const CropCrad = styled(Col)`
  margin-block-end: 10px;
`
const TextAdmin = styled.h3`
  float: left;
`

const Admin = () => {
  const [loading, setLoading] = useState(false)
  const [admins, setAdmins] = useState([])
  const [me, setME] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [adminsLineId, setAdminsLineId] = useState([])
  const [addModalVisible, setAddModalVisible] = useState(false)
  const [adminDetailModalVisible, setAdminDetailModalVisible] = useState(false)
  const [labelChecked, setLabelChecked] = useState('')
  const dispatch = useDispatch()

  const permissionsAdmin = CONSTANTS.permissionsAdmin

  let count = 0
  const badge = [
    'primary light',
    'secondary light',
    'success light',
    'danger light',
    'warning light',
    'info light',
    'light light',
    'dark light',
  ]
  const n = badge.length

  const fetchMe = async () => {
    try {
      const me = await callApi({
        url: '/admins/me',
      })
      setME(me)
    } catch (error) {
      console.log('error', error)
    }
  }
  useEffect(() => {
    fetchMe()
  }, [])

  const fetchAdmins = async (page) => {
    try {
      setLoading(true)
      dispatch({ type: 'loading_show' })
      const query = { page: page || 1 }
      const { _, results: admins } = await callApi({
        url: '/admins/line',
        query,
      })
      setFullPage(admins.length > 0 && true)
      setAdmins(admins)
      setAdminsLineId(admins.filter((s) => s.lineId))

      setLoading(false)
      dispatch({ type: 'loading_hide' })
      return admins
    } catch (error) {
      setAdmins([])
      setAdminsLineId([])
      setLoading(false)
      dispatch({ type: 'loading_hide' })
    }
  }

  const fetchAdmin = async (id) => {
    try {
      const response = await callApi({ url: `/admins/${id}` })
      setUsername(response.username)
      setDetail(response)
    } catch (error) {
      console.log('error admin', error)
    }
  }

  useEffect(() => {
    fetchAdmins()
      .then((res) => {
        setDetail(res[0])
        setUsername(res[0].username)
        setUsernameId(res[0].id)
      })
      .catch((err) => console.log('error', err))
  }, [])

  const [fullPage, setFullPage] = useState(false)
  const [detail, setDetail] = useState('')
  const [username, setUsername] = useState('')
  const [user_Id, setUsernameId] = useState('')
  const [permissions, setPermissions] = useState([])

  const onChangePage = (page) => {
    setCurrentPage(page)
    fetchAdmins(page)
  }

  const displayHeaderAdmin = () => {
    return (
      <Card.Header>
        <Card.Title>
          {fullPage && (
            <span
              className="badge"
              style={{
                borderRadius: '5rem',
                backgroundColor: 'red',
                color: 'white',
              }}
            >
              {admins.length}
            </span>
          )}
        </Card.Title>
        {fullPage ? (
          <span
            onClick={() => setFullPage(false)}
            className="badge"
            style={{
              borderRadius: '5rem',
              backgroundColor: '#000',
              color: 'white',
              cursor: 'pointer',
            }}
          >
            X
          </span>
        ) : (
          <span
            className="badge"
            style={{
              borderRadius: '5rem',
              backgroundColor: 'red',
              color: 'white',
            }}
          >
            {admins.length}
          </span>
        )}
      </Card.Header>
    )
  }

  const displayListAdminName = () => {
    return (
      <div className="card-body ">
        <PerfectScrollbar
          style={{ maxHeight: '70vh' }}
          id="DZ_W_Todo2"
          className="widget-media dz-scroll ps ps--active-y"
        >
          <ul className="timeline">
            {admins.map((item, index) => (
              <div
                onClick={() => {
                  setFullPage(true)
                  setDetail(item)
                  setUsername(item.name || item.username)
                  setPermissions(item.permissions)
                  setUsernameId(item.id)
                }}
                style={{ cursor: 'pointer' }}
                key={index}
              >
                <Card className=" mb-3 ">
                  <li className="p-3">
                    <div className="timeline-panel">
                      <div className="media-body">
                        <h5 className="mb-2 ">ผู้ใช้งาน</h5>
                        <h4 className="mb-2 text-muted">{item.name || item.username}</h4>
                      </div>
                      {item.lineId && <img src="/img/logo_line.png" width="30px" height="30px" alt="line logo"></img>}
                    </div>
                  </li>
                </Card>
              </div>
            ))}
          </ul>
        </PerfectScrollbar>
      </div>
    )
  }

  // Code อันเดิมเก็บไว้ก่อน
  // const displayAdminPermission = () => {
  //   return (
  //     <div className='card-body' style={{ height: '80vh', overflow: 'hidden' }}>
  //       <Card className='p-5'>
  //         <h2> ผู้ใช้งาน {username}</h2>
  //         <Row className=''>
  //           <Col className='p-3' md={12}>
  //             <ul className='list-group list-group-flush'>
  //               <li className='list-group-item d-flex justify-content-between'>
  //                 <span className='mb-0' style={{ color: '#3d4465' }}>
  //                   สิทธิ์การใช้งาน
  //                 </span>
  //                 <strong className='text'></strong>
  //               </li>
  //               <li className='list-group-item d-flex justify-content-between'>
  //                 <CardBadge>
  //                   {detail &&
  //                     detail.permissions !== undefined &&
  //                     detail.permissions.map((permission, i) => (
  //                       <BadgeCustom variant={badge[((i % n) + n) % n]} key={i}>
  //                         {permission}
  //                       </BadgeCustom>
  //                     ))}
  //                 </CardBadge>
  //               </li>
  //             </ul>
  //           </Col>
  //         </Row>
  //         <Card.Footer className=' d-sm-flex justify-content-between align-items-center'>
  //           <Card.Text>
  //             <Button
  //               className='mr-2 btn btn-secondary light'
  //               onClick={() => setAdminDetailModalVisible(true)}
  //             >
  //               เพิ่มผู้ดูแลระบบ
  //             </Button>
  //           </Card.Text>
  //           {username === me.username || (
  //             <Button
  //               className='mr-2 btn btn-danger light'
  //               onClick={async () => {
  //                 var confirmation = window.confirm(
  //                   `คุณต้องการลบ user: ${username} ใช่หรือไม่ ?`
  //                 );
  //                 if (confirmation) {
  //                   try {
  //                     dispatch({ type: 'loading_show' });
  //                     await callApi({
  //                       url: '/admins/' + user_Id,
  //                       method: 'DELETE',
  //                     });
  //                     dispatch({ type: 'loading_hide' });
  //                     alert('ลบข้อมูลสำเร็จ');
  //                     fetchAdmins();
  //                   } catch (err) {
  //                     console.log(err);
  //                     alert('ลบข้อมูลล้มเหลว');
  //                   }
  //                 }
  //                 return;
  //               }}
  //               disabled={username === me.username}
  //             >
  //               ลบ
  //             </Button>
  //           )}
  //         </Card.Footer>
  //       </Card>
  //     </div>
  //   );
  // };

  // ปรับ UI ใหม่
  const displayAdminPermission = () => {
    return (
      <div className="card-body" style={{ height: '80vh', overflow: 'hidden' }}>
        <Card className="p-5">
          <h2> ผู้ใช้งาน {username}</h2>
          <Row className="h-100 overflow-auto">
            <Col className="p-3">
              <p>สิทธิ์การใช้งาน</p>
              <hr />

              {detail &&
                detail.permissions !== undefined &&
                detail.permissions.map((permission, i) => (
                  <BadgeCustom variant={badge[((i % n) + n) % n]} key={i}>
                    {permission}
                  </BadgeCustom>
                ))}
            </Col>
          </Row>
          <Card.Footer className=" d-sm-flex justify-content-between align-items-center">
            <Card.Text>
              <Button className="mr-2 btn btn-secondary light" onClick={() => setAdminDetailModalVisible(true)}>
                เพิ่มสิทธิ์การใช้งาน
              </Button>
            </Card.Text>
            {username === me.username || (
              <Button
                className="mr-2 btn btn-danger light"
                onClick={async () => {
                  var confirmation = window.confirm(`คุณต้องการลบ user: ${username} ใช่หรือไม่ ?`)
                  if (confirmation) {
                    try {
                      dispatch({ type: 'loading_show' })
                      await callApi({
                        url: '/admins/' + user_Id,
                        method: 'DELETE',
                      })
                      dispatch({ type: 'loading_hide' })
                      alert('ลบข้อมูลสำเร็จ')
                      fetchAdmins()
                    } catch (err) {
                      console.log(err)
                      alert('ลบข้อมูลล้มเหลว')
                    }
                  }
                  return
                }}
                disabled={username === me.username}
              >
                ลบ
              </Button>
            )}
          </Card.Footer>
        </Card>
      </div>
    )
  }

  return (
    <Fragment>
      <Row>
        <CropCrad>
          <div>
            <TextAdmin>คนดูแลระบบ</TextAdmin>
          </div>
        </CropCrad>
      </Row>
      <Row>
        <Col sm={fullPage ? 12 : 3} lg={fullPage ? 12 : 3} md={fullPage ? 12 : 3} xl={fullPage ? 12 : 3}>
          <Card className={fullPage ? 'bg-warning' : 'bg-warning '}>
            <Row>
              <Col lg={fullPage ? 12 : 12} md={fullPage ? 12 : 12}>
                {displayHeaderAdmin()}
                <Row>
                  <Col md={fullPage ? 4 : 12} lg={fullPage ? 4 : 12}>
                    {displayListAdminName()}
                  </Col>
                  {fullPage && (
                    <Col md={8} lg={8}>
                      {displayAdminPermission()}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Pagination
        currentPage={currentPage}
        onPrevPage={() => onChangePage(currentPage - 1)}
        onNextPage={() => onChangePage(currentPage + 1)}
        items={admins}
        perPage={20}
      />
      <AddModal
        setIsVisible={setAddModalVisible}
        isVisible={addModalVisible}
        onClose={() => fetchAdmins(currentPage)}
      ></AddModal>
      {adminDetailModalVisible && (
        <AdminDetailModal
          setIsVisible={setAdminDetailModalVisible}
          isVisible={adminDetailModalVisible}
          admin={{ username, permissions, user_Id }}
          onClose={() => fetchAdmins(currentPage)}
          onSuccess={(id) => fetchAdmin(id)}
        ></AdminDetailModal>
      )}
    </Fragment>
  )
}

export default Admin
